import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { DevExMessageBoxcomponent } from '../../../devExtreme/src/devExMessagebox/devExMessagebox.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { MessageBoxModel } from './abcMessageBox';

@Component({
    selector: 'abcMessageBox',
    template: '<ng-template #abcMessageBox></ng-template>',
    standalone: false
})
export class AbcMessageBoxComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('abcMessageBox', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Output() onButtonClick = new EventEmitter();
  private componentRef;
  private _messageBox: MessageBoxModel;
  @Input()
  get messageBox() {
    return this._messageBox;
  }
  set messageBox(data) {
    if (this.componentRef) {
      this.componentRef.messageBox = data;
    }
    this._messageBox = data;
  }

  eventListener = [];
  style: ComponentStyle = ComponentStyle.DevExpress;
  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
  }

  ngOnInit() {
    this.createComponentInstance().subscribe((component) => {
      component.openMessageBox();
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {}

  ngOnDestroy(): void {
    this.eventListener = [];
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExMessageBoxcomponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.messageBox = this.messageBox;
          this.componentRef.onButtonClick.subscribe((e) => {
            this.onButtonClick.emit(e);
          });
          break;
        }
      }
      observer.next(this.componentRef);
    });
    return observable;
  }
}
